/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/core";
import { colors } from "../../../styles/defaultColors";
import { CircularProgress } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { DataEquipment, ListTableDestination } from "./List/ListTableHotel";
import { useTranslation } from "react-i18next";
import { ShowConfirmDialog } from "../../components/ShowConfirmDialog";
import { HotelService } from "./services/hotelService";
import { ContextMenuEquipment } from "./components/ContextMenuEquipment";
import { UserContext } from "../../../contexts/AppContext";
import { useLocation, useParams } from "react-router";
import { Helmet } from "react-helmet-async";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        listProperty: {},
        properties: {
            width: "100%",
            minHeight: 1000,
            textAlign: "center",

            [theme.breakpoints.down("sm")]: {
                minHeight: 1200,
            },
        },
        propertiesHeader: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        propertiesTitle: {
            fontSize: 22,
            fontFamily: "Josefin Sans",
            color: "#890608",
            marginTop: 40,
            textAlign: "center",
            margin: theme.spacing(2, 0),
        },
        propertiesCheck: {},
        propertiesCheckbox: {
            maxWidth: "60%",
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        showErrors: {},
        checkboxLabel: {
            "&:not(:last-child)": {
                marginBottom: 20,
            },
            "& span": {
                fontFamily: "Josefin Sans",
                color: "#5F5F5F",
            },
        },
        checkboxLegend: {
            textAlign: "left",
            fontSize: 18,
            fontFamily: "Josefin Sans",
            color: "#000000",
            marginBottom: 30,
        },
        checkboxGroup: {},
        propertiesBtn: {
            maxWidth: "60%",
            display: "flex",
            justifyContent: "space-between",

            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        Button: {
            fontFamily: "Josefin Sans",
            color: "#890608",
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },

        btn: {
            width: 180,
            height: 40,
            color: "#FFFFFF",
            textTransform: "initial",
            fontSize: 14,
            fontFamily: "Josefin Sans",
            marginBottom: 18,
            borderRadius: 100,
            background: "#890608",
            "&:hover": {
                background: "#EA7606",
            },
        },
        linkContainerButton: {
            textDecoration: "none",
        },
    })
);

const hotelService = new HotelService();
export const LisHotel = () => {
    const classes = styles();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [currentRow, setCurrentRow] = React.useState<DataEquipment>();
    const [hotel, setHotel] = React.useState<any>([]);
    const [selected, setSelected] = React.useState<string[]>([]);
    const [deleteMultiple, setDeleteMultiple] = React.useState<boolean>(false);
    const { t } = useTranslation();
    const userContext = React.useContext(UserContext);
    const { user } = userContext;
    const [openDialog, setOpenDialog] = React.useState(false);
    const [loadingPage, setLoadingPage] = React.useState(true);
    const params: { id: string } = useParams();
    const location = useLocation();
    // console.log({user})
    // React.useEffect(() => {
    //   hotelService
    //     .getAllHotel()
    //     .then((response) => {
    //       if (response.success) {
    //         setHotel(response.data);
    //         setLoadingPage(false);
    //       }
    //     })
    //     .catch((error) => {
    //       setLoadingPage(false);
    //     });
    // }, []);
    React.useEffect(() => {
        if (user._id !== "") {
            if (location.pathname.startsWith("/admin/hotels/list")) {
                if (params.id) {
                    hotelService
                        .getHotelByUser(params.id)
                        .then((response) => {
                            if (response.success) {
                                setHotel(response.hotel);
                                setLoadingPage(false);
                            }
                        })
                        .catch((err) => {
                            setLoadingPage(false);
                        });
                }
            } else {
                hotelService
                    .getHotelByUser(user._id)
                    .then((response) => {
                        if (response.success) {
                            setHotel(response.hotel);
                            setLoadingPage(false);
                        }
                    })
                    .catch((err) => {
                        setLoadingPage(false);
                    });
            }
        }
    }, [setLoadingPage, setHotel, user]);
    const handleClickConfirmDialog = () => {
        if (deleteMultiple) {
            //if(selected.length)deleteMany();
        } else {
            if (currentRow) deleteOne(currentRow?._id);
        }
    };

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const refreshEquipmentList = (id?: string) => {
        if (id) {
            setHotel(hotel.filter((hotel: any) => hotel._id !== id));
        } else {
            hotelService
                .getAllEquipments()
                .then((response) => {
                    if (response.success) {
                        setHotel(response.data.map((hotel: any) => {}));
                        setLoadingPage(false);
                    }
                })
                .catch((error) => {
                    setLoadingPage(false);
                });
        }
    };

    const deleteOne = (id: string) => {
        hotelService
            .deleteHotel(id)
            .then((response) => {
                if (response.success) {
                    setSelected(selected.filter((selId) => selId !== id));
                    refreshEquipmentList(id);
                }
                setDeleteMultiple(false);
            })
            .catch((error) => {
                console.log("list property context component error", error);
                setDeleteMultiple(false);
            });
        handleCloseDialog();
    };
    // const deleteMany = () => {
    //   hotelService
    //     .deleteHotel(selected)
    //     .then((response) => {
    //       console.log(response)
    //       if (response.success) {
    //         refreshEquipmentList()
    //         setSelected([]);
    //       }
    //       setDeleteMultiple(false);

    //     })
    //     .catch((error) => {
    //       console.log("list property context component error", error);
    //       setDeleteMultiple(false);
    //     });
    //     handleCloseDialog();
    // };

    const handleCloseContextMenu = () => {
        setAnchorEl(null);
    };

    const handleClickOpenContextMenu = (
        event: React.MouseEvent<HTMLAnchorElement>,
        row: DataEquipment
    ) => {
        setCurrentRow(row);
        setAnchorEl(event.currentTarget);
    };

    const handleDeleteSelectedRow = () => {
        handleClickOpenDialog();
        setDeleteMultiple(true);
    };

    const confirmDialog = ShowConfirmDialog({
        open: openDialog,
        handleClose: handleCloseDialog,
        handleConfirm: handleClickConfirmDialog,
        title:
            selected.length > 1
                ? t("hotel.supprimer-des-hotels")
                : t("hotel.supprimer-un-hotel"),
        description:
            selected.length > 1
                ? t("hotel.irreversible-un-hotel")
                : t("hotel.irreversible-des-hotels"),
    });
    return (
        <div>
            <Helmet>
                <title>{t('helmetListHotel.title')}</title>
                <meta name="description" content={t('helmetListHotel.description')} />
            </Helmet>

            <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography
                        variant="h5"
                        gutterBottom
                        className={classes.propertiesTitle}
                    >
                        {t("hotel.label.listHotel")}
                    </Typography>

                    {/* <Link
            to="/edit/hotel"
            className={classes.linkContainerButton}
          >
            <Button variant="text" className={classes.btn}>
              {t("hotel.ajout")}
            </Button>
          </Link> */}
                    {loadingPage && (
                        <CircularProgress
                            size={32}
                            style={{ color: "#890608" }}
                        />
                    )}
                    {!loadingPage && (
                        <ListTableDestination
                            openContextMenu={handleClickOpenContextMenu}
                            hotel={hotel}
                            handleDeleteMultipleRow={handleDeleteSelectedRow}
                            selected={selected}
                            setSelected={setSelected}
                            isLoading={loadingPage}
                        />
                    )}

                    <ContextMenuEquipment
                        handleClose={handleCloseContextMenu}
                        handleDeleteRow={handleClickOpenDialog}
                        open={open}
                        anchorEl={anchorEl}
                        row={currentRow}
                    />
                    {confirmDialog}
                </Grid>
            </Grid>
        </div>
    );
};
